export interface AuditJobRowForCustomerCheck {
    CustomerId?: number | null;
}

export interface AuditJobRowForAuditTypeCheck {
    AuditType?: string | null;
}

export function hasMultipleCustomersInMultiSelect(
    selectionCount: number,
    rows: AuditJobRowForCustomerCheck[]
): boolean {
    if (selectionCount <= 1) {
        return false;
    }
    const customerIds = new Set<number>();
    for (const row of rows) {
        if (row.CustomerId !== undefined && row.CustomerId !== null) {
            customerIds.add(row.CustomerId);
        }
    }
    return customerIds.size > 1;
}

export function hasMultipleAuditTypesInMultiSelect(
    selectionCount: number,
    rows: AuditJobRowForAuditTypeCheck[]
): boolean {
    if (selectionCount <= 1) {
        return false;
    }
    const auditTypes = new Set<string>();
    for (const row of rows) {
        const t =
            row.AuditType !== undefined && row.AuditType !== null && row.AuditType !== ""
                ? String(row.AuditType)
                : "__NONE__";
        auditTypes.add(t);
    }
    return auditTypes.size > 1;
}

export function getCsvSummaryExportErrorMessage(error: any, translate: (key: string) => string): string {
    return error?.response?.data?.Message || translate("Tooltip_Label_Error_Message");
}
